import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import RegexpInput from 'shared/components/RegexpInput/RegexpInput';
import { injectIntl, intlShape } from 'react-intl';
import cx from 'classnames';
import s from './TransportNumericOptions.css';

class TransportNumericOptions extends React.Component {
  static propTypes = {
    selectedActions: PropTypes.shape().isRequired,
    formState: PropTypes.shape().isRequired,
    //
    intl: intlShape.isRequired,
  };

  render() {
    const { formState, selectedActions, intl } = this.props;
    const selectedSetActions = selectedActions.set;

    const pricePlaceholder = `${intl.formatMessage({ id: 'Цена от' })}, ${(formState.currency &&
      formState.currency.title) ||
      intl.formatMessage({ id: 'грн' })}`;

    return (
      <div className={s.mainform}>
        <div className={s.filterItem}>
          <RegexpInput
            className={cx(s.input, s.from)}
            type="text"
            placeholder={pricePlaceholder}
            value={formState.priceFrom || ''}
            onChange={selectedSetActions.priceFrom}
            pattern={'^[0-9]+$'}
          />
          <RegexpInput
            className={cx(s.input, s.to)}
            type="text"
            placeholder={intl.formatMessage({ id: 'до' })}
            value={formState.priceTo || ''}
            onChange={selectedSetActions.priceTo}
            pattern={'^[0-9]+$'}
          />
        </div>
        <div className={s.filterItem}>
          <RegexpInput
            className={cx(s.input, s.from)}
            type="text"
            placeholder={intl.formatMessage({ id: 'Год, от' })}
            value={formState.yearFrom || ''}
            onChange={selectedSetActions.yearFrom}
            pattern={'^[0-9]+$'}
          />
          <RegexpInput
            className={cx(s.input, s.to)}
            type="text"
            placeholder={intl.formatMessage({ id: 'до' })}
            value={formState.yearTo || ''}
            onChange={selectedSetActions.yearTo}
            pattern={'^[0-9]+$'}
          />
        </div>
        <div className={s.filterItem}>
          <RegexpInput
            className={cx(s.input, s.from)}
            type="text"
            placeholder={intl.formatMessage({ id: 'Пробег от' })}
            value={formState.mileageFrom || ''}
            onChange={selectedSetActions.mileageFrom}
            pattern={'^[0-9]+$'}
          />
          <RegexpInput
            className={cx(s.input, s.to)}
            type="text"
            placeholder={intl.formatMessage({ id: 'до, тыс. км' })}
            value={formState.mileageTo || ''}
            onChange={selectedSetActions.mileageTo}
            pattern={'^[0-9]+$'}
          />
        </div>
      </div>
    );
  }
}

export default withStyles(s)(injectIntl(TransportNumericOptions));



// WEBPACK FOOTER //
// ./src/desktop/components/SearchPanelV2/TransportNumericOptions/TransportNumericOptions.js